import { PersonalizedGroupDTO } from './api/PersonalizedGroupDTO'
export class PersonalizedGroup {
  constructor(
    public id: string,
    public name: string,
    public levels?: string[],
    public defaultLevel?: string
  ) {}

  toDTO(): PersonalizedGroupDTO {
    return {
      ID_PERSONALIZED_GROUP: this.id,
      NAME: this.name,
      LEVELS: this.levels,
      DEFAULT_LEVEL: this.defaultLevel
    }
  }

  static fromDTO(
    personalizedGroupDTO: PersonalizedGroupDTO
  ): PersonalizedGroup {
    return new PersonalizedGroup(
      personalizedGroupDTO.ID_PERSONALIZED_GROUP,
      personalizedGroupDTO.NAME,
      personalizedGroupDTO.LEVELS || personalizedGroupDTO.VARIABLES,
      personalizedGroupDTO.DEFAULT_LEVEL
    )
  }
}
